"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlParser = void 0;
class HtmlParser {
    getDocumentBodyContent(htmlContent) {
        return new DOMParser().parseFromString(htmlContent, 'text/html');
    }
    getNodes(htmlText) {
        const document = this.getDocumentBodyContent(htmlText);
        const nodeListOfBody = document.querySelectorAll('body');
        return nodeListOfBody[0].childNodes;
    }
}
exports.HtmlParser = HtmlParser;
//# sourceMappingURL=HtmlParser.js.map